import { combineReducers  } from 'redux';
import main from './main/reducer';

const rootReducer = combineReducers({
    main
});

export default rootReducer;